import LoyaltyBenefits from './LoyaltyBenefits'

export default LoyaltyBenefits
